window.locales = window.locales || {};window.locales.am = window.locales.am || {};window.locales.am.preRecordedInterviewBox = window.locales.am.preRecordedInterviewBox || {};window.locales.am.preRecordedInterviewBox = {...window.locales.am.preRecordedInterviewBox, ...{
    "headerTitle": "ቃለ መጠይቅ",
    "headerSubtitle": "የእርስዎን ያካሂዱ",
    "ctaText": "ቃለ መጠይቅ ማካሄድ",
    "content": "እንኳን ደስ አላችሁ! ለአጭር የመግቢያ ቃለ መጠይቅ ተመርጠዋል። ለዝርዝሮች ኢሜልዎን ይመልከቱ።",
    "mobileContent": "ቃለ መጠይቅዎን ያካሂዱ",
    "mobileCtaText": "ቃለ መጠይቅ ማካሄድ"
}
};window.locales.ar = window.locales.ar || {};window.locales.ar.preRecordedInterviewBox = window.locales.ar.preRecordedInterviewBox || {};window.locales.ar.preRecordedInterviewBox = {...window.locales.ar.preRecordedInterviewBox, ...{
    "headerTitle": "مقابلة",
    "headerSubtitle": "قم بإجراء",
    "ctaText": "إجراء المقابلة",
    "content": "تهانينا! تم اختيارك لإجراء مقابلة قبول قصيرة. راجع بريدك الإلكتروني للمزيد من التفاصيل.",
    "mobileContent": "أجرِ مقابلتك",
    "mobileCtaText": "إجراء المقابلة"
}
};window.locales.en = window.locales.en || {};window.locales.en.preRecordedInterviewBox = window.locales.en.preRecordedInterviewBox || {};window.locales.en.preRecordedInterviewBox = {...window.locales.en.preRecordedInterviewBox, ...{
    "headerTitle": "Interview",
    "headerSubtitle": "Conduct Your",
    "ctaText": "Conduct Interview",
    "content": "Congratulations! You have been selected for a brief admissions interview. Check your email for details.",
    "mobileContent": "Conduct Your Interview",
    "mobileCtaText": "Conduct Interview"
}
};window.locales.es = window.locales.es || {};window.locales.es.preRecordedInterviewBox = window.locales.es.preRecordedInterviewBox || {};window.locales.es.preRecordedInterviewBox = {...window.locales.es.preRecordedInterviewBox, ...{
    "headerTitle": "Entrevista",
    "headerSubtitle": "Realice su",
    "ctaText": "Realizar entrevista",
    "content": "¡Felicitaciones! Has sido seleccionado para una breve entrevista de admisión. Revisa tu correo electrónico para más detalles.",
    "mobileContent": "Realice su entrevista",
    "mobileCtaText": "Realizar entrevista"
}
};window.locales.it = window.locales.it || {};window.locales.it.preRecordedInterviewBox = window.locales.it.preRecordedInterviewBox || {};window.locales.it.preRecordedInterviewBox = {...window.locales.it.preRecordedInterviewBox, ...{
    "headerTitle": "Colloquio",
    "headerSubtitle": "Conduci il tuo",
    "ctaText": "Condurre un'intervista",
    "content": "Congratulazioni! Sei stato selezionato per un breve colloquio di ammissione. Controlla la tua email per i dettagli.",
    "mobileContent": "Conduci il tuo colloquio",
    "mobileCtaText": "Condurre un'intervista"
}
};window.locales.zh = window.locales.zh || {};window.locales.zh.preRecordedInterviewBox = window.locales.zh.preRecordedInterviewBox || {};window.locales.zh.preRecordedInterviewBox = {...window.locales.zh.preRecordedInterviewBox, ...{
    "headerTitle": "面试",
    "headerSubtitle": "进行你的",
    "ctaText": "进行面试",
    "content": "恭喜！您已被选中参加简短的招生面试。请查看您的电子邮件了解详情。",
    "mobileContent": "进行面试",
    "mobileCtaText": "进行面试"
}
};